import React, { Component } from "react"
import { Switch, Route } from "react-router-dom"
import moment from "moment"
import { withTranslation } from "react-i18next"
import "./App.css"
import AdminFetcher from "./admin/AdminFetcher"
import AdminLogin from "./admin/AdminLogin"
import UserRoom from "./user/UserRoom"
import Error404 from "./errors/Error404"
import ScreenSizeError from "./errors/ScreenSizeError"

export default withTranslation()(
  class App extends Component {
    state = { mobile: null }

    componentDidMount() {
      const { i18n } = this.props

      this.updateDimensions()
      window.addEventListener("resize", this.updateDimensions)

      moment.updateLocale(
        i18n.language,
        i18n.language === "en"
          ? require("moment/locale/en-gb")
          : require("moment/locale/" + i18n.language)
      )

      if (localStorage.getItem("password")) {
        fetch(
          process.env.REACT_APP_SERVER_URL +
            "/checkAdminPassword?password=" +
            localStorage.getItem("password"),
          {
            method: "POST",
            headers: {},
          }
        ).then(async (response) => {
          if (response.status !== 200) {
            localStorage.setItem("password", "")
            this.forceUpdate()
            return
          }
        })
      }
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions)
    }

    updateDimensions = () => {
      const { mobile } = this.state

      if (window.innerWidth < 768) {
        !mobile && this.setState({ mobile: true })
      } else {
        mobile && this.setState({ mobile: false })
      }
    }

    render() {
      const { mobile } = this.state

      return mobile ? (
        <ScreenSizeError />
      ) : (
        <Switch>
          <Route path="/" exact>
            <UserRoom />
          </Route>
          <Route path="/admin">
            {localStorage.getItem("password") ? (
              <AdminFetcher />
            ) : (
              <AdminLogin forceUpdate={() => this.forceUpdate()} />
            )}
          </Route>
          <Route>
            <Error404 />
          </Route>
        </Switch>
      )
    }
  }
)
